// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ErrorFallBackCmp$Catalyst from "./ErrorFallBackCmp.bs.js";
import * as RescriptReactErrorBoundary from "../../../../../../@rescript/react/src/RescriptReactErrorBoundary.bs.js";

function ErrorBoundary(Props) {
  var children = Props.children;
  var fallBackComponent = Props.fallBackComponent;
  return React.createElement(RescriptReactErrorBoundary.make, {
              children: children,
              fallback: (function (params) {
                  return React.createElement(ErrorFallBackCmp$Catalyst.make, {
                              children: React.createElement(fallBackComponent, {
                                    error: params.error
                                  }),
                              error: params.error
                            });
                })
            });
}

var make = ErrorBoundary;

export {
  make ,
  
}
/* react Not a pure module */
